import { elementQueries } from '../elementQueries';
function normalizeElementQuery(component, elementQuery) {
    var normalizedRead = function () {
        var readDefinition = elementQuery.read;
        var node = readDefinition.selector ? component.node.querySelector(readDefinition.selector) : component.node;
        var computedStyles = getComputedStyle(node);
        // there is a case in Firefox, when getComputedStyle function returns null
        // https://bugzilla.mozilla.org/show_bug.cgi?id=548397
        if (!computedStyles) {
            return {};
        }
        return readDefinition.properties.reduce(function (styles, property) {
            styles[property] = computedStyles.getPropertyValue(property);
            return styles;
        }, {});
    };
    var normalizedApply = function (readResult) {
        return Object.keys(elementQuery.apply).reduce(function (hasChanged, property) {
            var newValue = elementQuery.apply[property].call(component, readResult);
            var oldValue = component[property];
            component[property] = newValue;
            return newValue !== oldValue || hasChanged;
        }, false);
    };
    return {
        read: elementQuery.read instanceof Function ? elementQuery.read.bind(component) : normalizedRead,
        apply: elementQuery.apply instanceof Function ? elementQuery.apply.bind(component) : normalizedApply
    };
}
export var prototypeAdditions;
(function (prototypeAdditions) {
    function __defineElementQueries() {
        var _this = this;
        this.__elementQueries = this.__elementQueriesDefinitions.map(function (elementQuery) {
            return normalizeElementQuery(_this, elementQuery);
        });
    }
    prototypeAdditions.__defineElementQueries = __defineElementQueries;
    function __attachElementQueries() {
        this.__elementQueries.forEach(function (elementQuery) { return elementQueries.addElementQuery(elementQuery); });
    }
    prototypeAdditions.__attachElementQueries = __attachElementQueries;
    function __detachElementQueries() {
        this.__elementQueries.forEach(function (elementQuery) { return elementQueries.removeElementQuery(elementQuery); });
    }
    prototypeAdditions.__detachElementQueries = __detachElementQueries;
})(prototypeAdditions || (prototypeAdditions = {}));
export function extendComponent(customPrototype, definition) {
    customPrototype.__elementQueriesDefinitions = (definition.elementQueries || []);
}
//# sourceMappingURL=ElementQueriesHandling.js.map